
import {defineComponent, PropType, computed, ref} from 'vue';

export default defineComponent({
  name: 'PostItem',
  props: {
    company: String,
    title: String,
    oneColImage: String,
    twoColImage: String,
    threeColImage: String,
    link: String,
    featured: Boolean,
    index: {
      type: Number as PropType<number>,
      required: true
    },
    isLast: Boolean,
    titleColor: String,
    titlePosition: String,
    backgroundColor: String,
    backgroundType: String
  },
  setup(props) {
    const computedData = computed(() => {
      const classes: string[] = ['grid__item'];
      let imageSrc = '';
      const backgroundColor = ref('');

      let count = props.index + 1;
      let rowNumber = Math.ceil(count / 2);

      // If row is even...
      if (props.isLast && props.index % 2 === 0) {
        imageSrc = props.threeColImage ?? '';
        classes.push('grid__item--full');
      } else if (rowNumber % 2 === 0) {
        // If count is even...
        if (count % 2 === 0) {
          imageSrc = props.twoColImage ?? '';
          classes.push('grid__item--double');
        } else {
          imageSrc = props.oneColImage ?? '';
          classes.push('grid__item--single');
        }
        // If row is odd...
      } else {
        // If count is even...
        if (count % 2 === 0) {
          imageSrc = props.oneColImage ?? '';
          classes.push('grid__item--single');
        } else {
          imageSrc = props.twoColImage ?? '';
          classes.push('grid__item--double');
        }
      }

      if (props.titleColor === 'dark') {
        classes.push('grid__item--dark');
      } else {
        classes.push('grid__item--white');
      }

      if (props.titlePosition === 'top') {
        classes.push('grid__item--top');
      } else {
        classes.push('grid__item--bottom');
      }

      if (props.backgroundColor && props.backgroundType === 'color') {
        backgroundColor.value = props.backgroundColor;
      }

      return {
        classes,
        imageSrc
      }
    });

    return {
      computedData
    }
  }
});
